import axios from 'axios';
import CacheKeyBuilder from './infra/CacheKeyBuilder';
import UserDataService from './services/UserDataService';
import Transaction from './models/Transaction';
import StockObjective from './models/StockObjective';
import storageService from './services/StorageService';

async function getCacheKey(config) {
    const cacheKeyBuilder = new CacheKeyBuilder();
    return await cacheKeyBuilder.buildFromHttpRequest({ url: config.url, body: config.data });
}

export function registerAxiosInterceptors(store) {
    const urlsToIntercept = [
        '/api/Portfolio/AddOrUpdateObjective',
        '/api/Portfolio/UpdatePortfolio',
        '/api/Portfolio/AddPortfolioStockBuyLot',
        '/api/Portfolio/AddPortfolioStockSellLot',
        '/api/Portfolio/DeletePortfolio',
        '/api/Portfolio/UpdatePortfolioStockLot',
        '/api/Portfolio/DeletePortfolioStockLot',
        '/api/UserBuyStockList/V2/AddEntry',
        '/api/UserSellStockList/V2/AddEntry',
        '/api/UserBuyStockList/V2/DeleteEntry',
        '/api/UserSellStockList/V2/DeleteEntry',
        '/api/UserPreference/AddOrUpdate',
        '/api/Portfolio/DeleteObjective'
    ];
    const urlsToCache = [
        '/api/StockEvolution/GetInterval'
    ];

    axios.interceptors.response.use(
        async response => {
            const url = response.config.url || '';
            const useCache = urlsToCache.includes(url);
            if (useCache) {
                const cacheKey = await getCacheKey(response.config);
                await storageService.saveResponseToCache(cacheKey, response.data);
            }
            if (urlsToIntercept.includes(url)) {
                console.log('--Interception:', url);
                // Vous pouvez ici déclencher des actions Vuex ou effectuer d'autres opérations
                // Par exemple, si vous souhaitez mettre à jour les données utilisateur après une modification de portefeuille :
                // const { portfolioId, portfolioName, portfolioDescription, currency } = response.data;
                // store.dispatch('list/updatePortfolioInfos', { portfolioId, portfolioName, portfolioDescription, currency });

                // Si vous avez besoin de récupérer les données utilisateur par défaut après une modification :
                UserDataService.getDefaultUserDataPackage().then((response) => {
                    console.log(response)
                    const transactions = response.transactions.map(t => new Transaction({ ...t }))
                    const stockObjectives = response.stockObjectives.map(so => new StockObjective({ ...so }));
                    store.dispatch('updateAllPortfolioInfos', {
                        portfolios: response.portfolios,
                        transactions,
                        stockObjectives
                    });
                })
            }

            return Promise.resolve(response);
        },
        error => {
            if (error.__fromCache) {
                return Promise.resolve({ data: error.cachedData, config: error.config });
            }

            return Promise.reject(error);
        }
    );

    axios.interceptors.request.use(async (config) => {
        const useCache = urlsToCache.includes(config.url);
        if (useCache) {
            const ttl = 3600000; // 1 heure en millisecondes
            const cacheKeyBuilder = new CacheKeyBuilder();
            const cachKey = await cacheKeyBuilder.buildFromHttpRequest({ url: config.url, body: config.data });
            const cached = await storageService.getCachedHttpResponse(cachKey, ttl);
            if (cached) {
                return Promise.reject({ __fromCache: true, cachedData: cached, config });
            }
        }
        return config; // sinon on continue normalement
    });
}